var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSun = function SvgSun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.356 5.643a3.333 3.333 0 1 1-4.714 4.714 3.333 3.333 0 0 1 4.714-4.714M8 2.667V1.333M8 14.667v-1.334M12.24 3.76l.473-.473M3.286 12.713l.473-.473M13.333 8h1.333M1.333 8h1.333M12.24 12.24l.473.473M3.286 3.287l.473.473",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSun;